import classNames from 'classnames'
import React, { forwardRef } from 'react'

import type { RowProps } from './types'
import { useIsMobileView } from '../../hooks'
const Row = ({ className, ...props }: RowProps) => {
  const isMobile = useIsMobileView()

  const rowClassName = classNames(
    'csg-tw-table-row [&:hover_td]:!bg-primary-light',
    { 'h-10': !isMobile },
    className
  )

  const RowWithRef = forwardRef<HTMLTableRowElement, RowProps>((props, ref) => (
    <tr ref={ref} className={rowClassName} {...props} />
  ))

  RowWithRef.displayName = 'Row'
  return <RowWithRef {...props} />
}

export default Row
